import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OtEvent, Organization } from 'src/app/domain/ot-event';
import { RegistrationService, PaymentCodeResponse } from 'src/app/shared';

@Component({
  selector: 'app-ot-registration-success',
  templateUrl: './ot-registration-success.component.html',
  styleUrls: ['./ot-registration-success.component.scss']
})
export class OtRegistrationSuccessComponent implements OnInit {

  public registration: any;
  public otEvent: OtEvent;
  public bankPaymentConfig: any;
  public organization: Organization;
  public paymentCodeResponse: PaymentCodeResponse;

  private registrationId: number;
  private secureHash: string;

  constructor(
      private registrationService: RegistrationService,
      route: ActivatedRoute
  ) {
    this.registrationId = Number.parseInt(route.snapshot.paramMap.get('registrationId'), 10);
    this.secureHash = route.snapshot.paramMap.get('secureHash');
  }

  ngOnInit() {
    this.registrationService.getByIdAndHash(this.registrationId, this.secureHash).then(registration => {
      this.registration = registration;
      this.otEvent = registration.otEvent;
      if (registration.paymentTypeConfig && registration.paymentTypeConfig.bankPaymentConfig) {
        this.bankPaymentConfig = registration.paymentTypeConfig.bankPaymentConfig;
      }
      this.organization = registration.otEvent.organization;
    });

    this.registrationService.getPaymentCode(this.registrationId, this.secureHash).then(paymentCodeResponse => {
      if (! paymentCodeResponse) {
        return;
      }
      this.paymentCodeResponse = paymentCodeResponse;
    });
  }
}
